import { render, staticRenderFns } from "./exames-entregas.vue?vue&type=template&id=c6545a00&"
import script from "./exames-entregas.vue?vue&type=script&lang=js&"
export * from "./exames-entregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports